import {ColDef} from "ag-grid-community";
import {FormatCurrencyPipe} from "../pipes/format-currency.pipe";

/**
 * Creates the shared column definitions for charity/group breakdown grids.
 * Used by both standard-game-report and comprehensive-report-by-date-range.
 *
 * @param currencyPipe - The currency pipe for formatting values
 * @returns Array of column definitions for ag-grid
 */
export function createGroupBreakdownColumnDefs(currencyPipe: FormatCurrencyPipe): ColDef[] {
  return [
    {
      headerName: 'Group',
      resizable: true,
      sortable: true,
      field: 'Name',
      flex: 1
    },
    {
      headerName: 'Gross',
      resizable: true,
      sortable: true,
      field: 'CharityContribution',
      flex: 1,
      valueFormatter: params => {
        const converted = currencyPipe.transform(params.value);
        return converted ? converted : '';
      }
    },
    {
      headerName: 'Refund Fees',
      resizable: true,
      sortable: true,
      field: 'RefundAmount',
      flex: 1,
      valueFormatter: params => {
        const converted = currencyPipe.transform(params.value);
        return converted ? converted : '';
      }
    },
    {
      headerName: 'Dispute Fees',
      resizable: true,
      sortable: true,
      field: 'DisputeAmount',
      flex: 1,
      valueFormatter: params => {
        const converted = currencyPipe.transform(params.value);
        return converted ? converted : '';
      }
    },
    {
      headerName: 'Net',
      resizable: true,
      sortable: true,
      valueGetter: p => p.data.CharityContribution - p.data.RefundAmount - p.data.DisputeAmount,
      flex: 1,
      valueFormatter: params => {
        const converted = currencyPipe.transform(params.value);
        return converted ? converted : '';
      }
    },
    {
      headerName: 'Number of Players',
      resizable: true,
      wrapHeaderText: true,
      sortable: true,
      flex: 1,
      field: 'TotalNumberOfPlayers'
    }
  ];
}
